export const LOCAL_PROXY_URL = 'http://localhost:8810';
export const LOCAL_SERVER_DOMAIN = 'fastlocal.com';

export const LOCALHOST_DOMAINS = ['localhost', 'fastlocal.com'];
